import * as API from '@/services/API';

export default {
  get(id) {
    return API.apiClient.get(`/family-member-relationship/${id}`);
  },
  list(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/family-member-relationship/${query}`);
  },
  async delete(id) {
    return API.apiClient.delete(`/family-member-relationship/${id}`);
  },
  paginate(link) {
    return API.apiClient.get(link);
  },
  async save(id, data) {
    if (id == 0) {
      return API.apiClient.post(`/family-member-relationship`, data);
    } else {
      return API.apiClient.put(`/family-member-relationship/${id}`, data);
    }
  },
  search(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/family-member-relationship/search${query}`);
  }
};
